import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledHouzzG = styled.g`
    fill: ${(props) => props.theme.colors.brand};
`;

const Icon = ({ fill = '#222' }) => {
    return (
        <svg
            version="1.1"
            xmlSpace="preserve"
            width="114px"
            height="26px"
            viewBox="0 0 570 130"
            preserveAspectRatio="xMidYMid meet"
        >
            <g fill={fill}>
                <path d="M312.93,64.24A37.67,37.67,0,0,0,251.68,76a36.16,36.16,0,0,0-2.91,14.46,36.7,36.7,0,0,0,10.87,26.29,38,38,0,0,0,11.9,7.89,38.81,38.81,0,0,0,29.47,0,38,38,0,0,0,11.9-7.89A36.71,36.71,0,0,0,323.8,90.46,36.12,36.12,0,0,0,320.89,76,37.9,37.9,0,0,0,312.93,64.24Zm-7.16,35.28a20.23,20.23,0,0,1-4.15,7,19.35,19.35,0,0,1-6.56,4.55,23.82,23.82,0,0,1-17.55,0,19.3,19.3,0,0,1-6.56-4.55,20.12,20.12,0,0,1-4.16-7,28.17,28.17,0,0,1,0-18.14,20.14,20.14,0,0,1,4.16-7,19.32,19.32,0,0,1,6.56-4.55,23.75,23.75,0,0,1,17.55,0,19.34,19.34,0,0,1,6.56,4.55,20.27,20.27,0,0,1,4.15,7,28.19,28.19,0,0,1,0,18.14Z" />
                <polygon points="481.42 68.48 481.42 55.12 425.6 55.12 425.6 69.07 461.27 69.07 424.31 112.35 424.31 125.85 483.43 125.85 483.43 111.9 444.19 111.9 481.42 68.48" />
                <polygon points="518.22 111.9 555.45 68.48 555.45 55.12 499.63 55.12 499.63 69.07 535.3 69.07 498.34 112.35 498.34 125.85 557.46 125.85 557.46 111.9 518.22 111.9" />
                <path d="M215.81,55.76c-10.44-4.32-23.25-2.54-31.54,4.14V30.13H168.61v95.71h15.67V88.21c0-7.16,2.06-19.17,15.83-19.17,12.64,0,17.13,10.33,17.13,19.17v37.62h15.65V83.06C232.88,70.2,226.66,60.25,215.81,55.76Z" />
                <path d="M390.76,93.74a25.33,25.33,0,0,1-.91,6.55,17.93,17.93,0,0,1-2.94,6h0a15.35,15.35,0,0,1-5.27,4.41,20.35,20.35,0,0,1-16.25,0,15.37,15.37,0,0,1-5.27-4.41,17.82,17.82,0,0,1-2.94-6,25.5,25.5,0,0,1-.92-6.55V55H340.72V95.3c0,15,6.62,25,19.95,30a37.8,37.8,0,0,0,25.86-.06c16.36-6.18,19.79-19.72,19.79-30V55.17H390.76Z" />
            </g>
            <StyledHouzzG>
                <polygon
                    className="cls-1"
                    points="70.28 125.84 112.5 125.84 112.5 54.36 27.99 30.13 27.99 0 0 0 0 125.84 42.22 125.84 42.22 86.22 70.28 86.22 70.28 125.84"
                />
            </StyledHouzzG>
        </svg>
    );
};

Icon.propTypes = {
    fill: PropTypes.string,
};

export default Icon;
